import { render, staticRenderFns } from "./Estadisticas.vue?vue&type=template&id=50f317fc&scoped=true&"
import script from "./Estadisticas.vue?vue&type=script&lang=js&"
export * from "./Estadisticas.vue?vue&type=script&lang=js&"
import style0 from "./Estadisticas.vue?vue&type=style&index=0&id=50f317fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f317fc",
  null
  
)

export default component.exports